export default __webpack_public_path__ + "static/media/health6.fcc6a21b.png";